import Vue from 'vue'
import App from './App.vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueLazyload from 'vue-lazyload'
import router from './router'
import store from './store/'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import Vuebar from 'vuebar'
import VueGtag from 'vue-gtag'

Vue.use(Vuebar)

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_G_API_KEY,
    libraries: 'places'
  }
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: '/img/spinner.gif',
  attempt: 1
})

if (process.env.VUE_APP_G_TAG_ID) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_G_TAG_ID }
  })
}

// Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
